import React, { useState } from 'react';
import { Package, Truck, Globe, MapPin, Phone, Mail, Shield } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useToast } from '../hooks/use-toast';
import { Helmet } from 'react-helmet-async';

const ShippingCanadaToBangladeshPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '' });
  const { toast } = useToast();
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    toast({ title: "Quote Request Received!", description: "We'll contact you within 24 hours." });
    setFormData({ name: '', email: '', phone: '' });
  };

  return (
    <>
      <Helmet>
        <title>Shipping from Canada to Bangladesh | International Courier – Shippzy</title>
        <meta name="description" content="Ship parcels from Canada to Bangladesh. Affordable international courier with DHL, FedEx, UPS. Door-to-door delivery, customs assistance, real-time tracking." />
        <link rel="canonical" href="https://www.shippzy.ca/shipping-canada-to-bangladesh" />
      </Helmet>
      <div className="min-h-screen bg-white">
        <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">Shipping from Canada to Bangladesh</h1>
              <p className="text-xl text-gray-300 mb-8">Shippzy offers reliable international shipping from Canada to Bangladesh. We work with DHL, FedEx, and UPS for competitive rates and dependable delivery.</p>
              <Button className="bg-gradient-to-r from-red-600 to-yellow-500 hover:from-red-700 hover:to-yellow-600 text-white px-8 py-6 text-lg" onClick={() => document.getElementById('quote-form').scrollIntoView({ behavior: 'smooth' })}>Get Quote</Button>
            </div>
          </div>
        </section>
        <section id="quote-form" className="py-20 bg-gradient-to-r from-red-600 to-yellow-500">
          <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="shadow-2xl">
              <CardHeader><CardTitle className="text-2xl text-center">Get Free Quote to Bangladesh</CardTitle></CardHeader>
              <CardContent>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <Input name="name" value={formData.name} onChange={handleChange} required placeholder="Your name" />
                  <Input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="your@email.com" />
                  <Input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="+1 (123) 456-7890" />
                  <Button type="submit" className="w-full bg-gradient-to-r from-red-600 to-yellow-500 text-white h-12">Get Quote Now</Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </section>
      </div>
    </>
  );
};

export default ShippingCanadaToBangladeshPage;
